import { useControllableState } from '../../../utils/useControllableState'
import { getDatePickerTriggerProps, SingleDatePickerProps } from '../DatePicker.types'
import { DatePickerCalendar } from '../DatePickerCalendar'
import { useDatePickerOpenState } from '../useDatePickerOpenState'

export function SingleDatePicker(props: SingleDatePickerProps) {
  const {
    className,
    label,
    helpText,
    status = 'default',
    feedbackText,
    placeholder,
    disabled,
    defaultOpen = false,
    defaultValue = null,
    value,
    minDate,
    maxDate,
    excludeDates,
    includeDates,
    locale = 'en-GB',
    dateFormat = 'dd.MM.yyyy',
    nextMonthAriaLabel = 'Go to next month',
    previousMonthAriaLabel = 'Go to previous month',
    showWeekNumbers,
    weekLabel = 'Week',
    monthsShown = 1,
    inline = false,
    onChange,
    highlightStartDate,
    highlightEndDate,
  } = props
  const [selectedDate, setSelectedDate] = useControllableState<Date | null>(value, defaultValue)
  const { isOpen, handleOpen, handleClose, handleKeyDown } = useDatePickerOpenState(defaultOpen, disabled, inline)
  const hasHighlightRange = Boolean(highlightStartDate && highlightEndDate)

  const handleDateChange = (value: Date | [Date | null, Date | null] | null) => {
    const nextSelectedDate = value instanceof Date ? value : null
    setSelectedDate(nextSelectedDate)
    onChange?.(nextSelectedDate)
  }

  const handleDateSelect = () => {
    handleClose()
  }

  return (
    <DatePickerCalendar
      className={className}
      label={label}
      helpText={helpText}
      status={status}
      feedbackText={feedbackText}
      placeholder={placeholder}
      disabled={disabled}
      isOpen={isOpen}
      minDate={minDate}
      maxDate={maxDate}
      excludeDates={excludeDates}
      includeDates={includeDates}
      {...getDatePickerTriggerProps(props)}
      locale={locale}
      dateFormat={dateFormat}
      nextMonthAriaLabel={nextMonthAriaLabel}
      previousMonthAriaLabel={previousMonthAriaLabel}
      shouldCloseOnSelect
      selected={selectedDate}
      startDate={highlightStartDate}
      endDate={highlightEndDate}
      highlightRange={hasHighlightRange}
      onChange={handleDateChange}
      onSelect={handleDateSelect}
      onOpen={handleOpen}
      onClose={handleClose}
      onKeyDown={handleKeyDown}
      showWeekNumbers={showWeekNumbers}
      weekLabel={weekLabel}
      monthsShown={monthsShown}
      inline={inline}
    />
  )
}
